const CHUNK_LOAD_ERROR_PATTERNS = [
	/ChunkLoadError/i,
	/Loading chunk .* failed/i,
	/Failed to fetch dynamically imported module/i,
	/Importing a module script failed/i,
];

function safeRead(value, reader) {
	try {
		return reader(value);
	} catch {
		return '';
	}
}

/**
 * Detects whether an error represents a deployment-related dynamic import failure
 * (stale chunk after deploy, failed module script load, etc.).
 *
 * @param {unknown} error
 * @returns {boolean}
 */
export function isChunkLoadError(error) {
	if (error == null) {
		return false;
	}

	const haystack = [
		safeRead(error, (e) => e.name),
		safeRead(error, (e) => e.message),
		safeRead(error, (e) => (typeof e.toString === 'function' ? e.toString() : '')),
	]
		.filter((part) => part != null && part !== '')
		.join(' ');

	return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(haystack));
}
